const routes = {
  notFound: {
    pathname: '/404',
    pageTitle: '404',
  },
  home: {
    pathname: '/',
    component: 'containers/HomePage/MainPage',
    pageTitle: 'Movebo-Group',
  },
  setup: {
    pathname: '/setup',
    component: 'pages/setup/setup',
    pageTitle: 'Setup',
  },
  pay: {
    pathname: '/pay',
    component: 'pages/pay/pay',
    pageTitle: 'Pay',
  },
  privacyPolicy: {
    pathname: '/privacy-policy',
    component: 'pages/privacyPolicy/privacyPolicy',
    pageTitle: 'Privacy Policy',
  },
  termsCondition: {
    pathname: '/terms-and-conditions',
    component: 'pages/termsCondition/termsCondition',
    pageTitle: 'Terms & Conditions',
  },
  thankYou: {
    pathname: '/thank-you/:email',
    component: 'pages/auth-pages/thank-you.page',
    pageTitle: 'Thank You',
  },
  login: {
    pathname: '/admin',
    component: 'pages/auth-pages/sign-in.page.js',
    pageTitle: 'login',
  },
  admin: {
    pathname: '/admin/:page',
    component: 'pages/admin/admin.page.js',
    pageTitle: 'Movebo Admin',
  },
};

export default routes;
